import React from 'react'

import { AssignmentTurnedIn } from '@material-ui/icons'

import './Prefer.css'

const Perfer = () => {
    return (
        <div className="template__sec5 container">
            <h2 className="font-heading py-40 text-center mx-auto">Why Clients Prefer Us</h2>
            <p className="text-center mx-auto">
                We do not sacrifice quality for affordability, we give all our clients the best. We show clients that we take deadlines seriously and can deliver work on time, promote your skills as an expert in the industry, and we have more valuable translator that demonstrate unique translation skills and natural speaking abilities.
            </p>
            <div className="grid c-2 gap-40 py-40">
                <div className="p-20">
                    <h3 className="d-flex align-center justify-center m-20 text-capitalise"><AssignmentTurnedIn className="mr-10" /> native speaking abilities </h3>
                    <p className="m-20 text-center">
                        One Converse Hac is a company that specializes in providing native-speaking translators. The company's team of translators are all native speakers who have an excellent command of the languages they translate. They offer this service for many different industries, including healthcare, government, and financial services.
                    </p>
                </div>
                <div className="p-20">
                    <h3 className="d-flex align-center justify-center m-20 text-capitalise"><AssignmentTurnedIn className="mr-10" /> Effective Communication skill </h3>
                    <p className="m-20 text-center">
                        Their goal is to help organizations communicate more effectively with their global customers or partners by offering high quality translations in over 100 languages. All translations are done by human translators only, not automated software solutions like Google Translate or Bing Translator which can sometimes be inaccurate or create unintended meanings in the translated text.
                    </p>
                </div>
                <div className="p-20">
                    <h3 className="d-flex align-center justify-center m-20 text-capitalise"><AssignmentTurnedIn className="mr-10" /> punctuality</h3>
                    <p className="m-20 text-center">
                        We show clients that you take deadlines seriously and can deliver work on time, clients will not only pay attention to your proven translation ability and past experience, but will also be looking at how punctually you deliver completed work to your clients, or even how quickly you reply to their enquiry emails.
                    </p>
                </div>
                <div className="p-20">
                    <h3 className="d-flex align-center justify-center m-20"><AssignmentTurnedIn className="mr-10" /> Customer Care Service</h3>
                    <p className="m-20 text-center">
                        Our Customer service is always responsive. Whether customers engage with the translation company by email, phone, live chat, or through social media, they should receive prompt responses. our translation services operate through a global network of language professionals, so as a business we never sleep. This means that we provide customer care 24/7 in response to the needs of clients around the world.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Perfer
